import ApiDocs from 'docs/src/modules/components/ApiDocs';
import api from 'docs/pages/x/api/data-grid/grid-editing-api.json';

export default function EditApiNoSnap() {
  return <ApiDocs api={api} />;
}
